import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const BelimoLoadingIcon = memo(() => (
    <IconWrapper>
        <svg className="vss-main-layout__loading-icon" fill="none" viewBox="0 0 100 100">
            <circle
                className="vss-main-layout__loading-stroke"
                cx="50%"
                cy="50%"
                r="44"
                fill="none"
                stroke="currentColor"
                strokeDashoffset={50}
                strokeWidth={7}
                strokeDasharray={150}
            />
        </svg>
    </IconWrapper>
));
